import axios from "axios";
import { base_url } from "../config";

const accessToken = localStorage.getItem("@user");

export const fetchBookedList = async () => {
  try {
    const response = await axios.get(`${base_url}/table-booking/booked-all-my-list?limit=30`, {
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    return response.data.items;
  } catch (error) {
    console.error("Error fetching booked list:", error.response?.data || error.message);
    throw error;
  }
};
export const fetchUpcomingBookedList = async () => {
  try {
    const response = await axios.post(`${base_url}/table-booking/next-upcoming-event`,
      { user_id  : localStorage.getItem("@userAccount") }, 
      {
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    return response.data.data;
  } catch (error) {
    console.error("Error fetching booked list:", error.response?.data || error.message);
    throw error;
  }
};

export const isIdInBookedList = async (idToCheck) => {
  try {
    const bookedItems = await fetchBookedList();
    const unpaidItems = bookedItems.filter((item) => item.payment_id);
    const tableIds = unpaidItems.map((item) => item.table_details.id); // Extract all IDs under table_details
    return tableIds.includes(idToCheck); // Check if the given ID exists in the array
  } catch (error) {
    console.error("Error checking ID in booked list:", error.message);
    throw error; // Re-throw error for the caller to handle
  }
};

export const isIdInUnpaidList = async (idToCheck) => {
  try {
    const bookedItems = await fetchBookedList();
    // Filter items where payment_id is null
    const unpaidItems = bookedItems.filter((item) => !item.payment_id);
    const matchingItem = unpaidItems.find(
      (item) => item.table_details.id === idToCheck
    );

    if (matchingItem) {
      return { exists: true, order_id: matchingItem.order_id };
    }
    return { exists: false, order_id: null };
  } catch (error) {
    console.error("Error checking ID in unpaid list:", error.message);
    throw error; // Re-throw error for the caller to handle
  }
};
